module.exports = __webpack_public_path__ + "static/media/support-text.b72f72bd.png";